var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"notification",style:({'max-width': '1500px'})},[_c('TableNotifications',{attrs:{"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }